// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#domain-search-app {
  background-color: #f7f7f7;
}
@media screen and (max-width: 767px) {
  #domain-search-app:has(.DomainSearchInputDomains) {
    background-color: white;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.less"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;AACE;EACE;IACE,uBAAA;EACJ;AACF","sourcesContent":["#domain-search-app {\n  background-color: #f7f7f7;\n\n  @media screen and (max-width: 767px) {\n    &:has(.DomainSearchInputDomains) {\n      background-color: white;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
